/**
 * //验证手机号码
 */
export const isPhoneNumber = (phoneNumber) => {
  if (!(/^1[3456789]\d{9}$/.test(phoneNumber))) {
    return false
  }
  return true
}

export const tableThousands = function (value) {
  if (!value) {
    return 0
  }
  if (value.toString().length < 4) {
    return value
  }
  let reg = /^[0-9]+.?[0-9]*$/
  if (!reg.test(value.toString())) {
    return value
  }
  return value.toString().replace(/\d+/, function (n) { // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
      return $1 + ','
    })
  })
}


// WEBPACK FOOTER //
// ./src/utils/validate.js